export default "__VITE_ASSET__dGdo9LRD__"